var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReviewsEmpty = function SvgReviewsEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M5.333 35.892v19.893c0 2.236 2.587 3.48 4.333 2.082l7.54-6.032a5.333 5.333 0 0 1 3.332-1.168h24.796c7.363 0 13.333-5.97 13.333-13.334v-16C58.667 13.97 52.697 8 45.333 8H18.668C11.303 8 5.333 13.97 5.333 21.333v4.307"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "m34 18.665-.63-1.05a1.6 1.6 0 0 0-2.743-.002l-3.105 5.16a1.6 1.6 0 0 1-1.01.734l-5.871 1.36a1.6 1.6 0 0 0-.847 2.607l3.95 4.55a1.6 1.6 0 0 1 .386 1.188l-.144 1.657M36.224 22.35l.254.422a1.6 1.6 0 0 0 1.01.734l5.87 1.36a1.6 1.6 0 0 1 .848 2.607l-3.95 4.55a1.6 1.6 0 0 0-.386 1.188l.52 6.004a1.6 1.6 0 0 1-2.218 1.611l-5.548-2.35a1.6 1.6 0 0 0-1.249 0l-5.841 2.474a1.409 1.409 0 0 1-1.953-1.419v0l.05-.583"
  })));
};
export default SvgReviewsEmpty;